<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="备注">
                <a-input v-model="queryParam.remark" placeholder="请输入备注" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="盘点批次号">
                <a-input v-model="queryParam.checkBatchNo" placeholder="请输入盘点批次号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.checkStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">审核通过</a-select-option>
                  <a-select-option :value="2">审核不通过</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:check:create']">
          <a-icon type="plus" />创建盘点批次
        </a-button>
      </div>

      <create-form ref="createForm" @ok="getList" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="checkStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">{{ parseTime(text) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:check:query']"><a-icon type="eye" />详情</a>
          <a-divider type="vertical" v-if="record.checkStatus === 0" />
          <a @click="handleApprove(record)" v-if="record.checkStatus === 0" v-hasPermi="['retail:check:approve']"><a-icon type="check" />审核</a>
        </span>
      </a-table>
    </a-card>

    <a-modal title="盘点详情" :visible="detailVisible" :footer="null" @cancel="detailVisible = false" width="1000px">
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="盘点批次号">{{ currentDetail.checkBatchNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ currentDetail.orgName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="盘点状态">
          <a-tag :color="getStatusColor(currentDetail.checkStatus)">{{ currentDetail.checkStatusName || getStatusText(currentDetail.checkStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="盘点总数" >{{ currentDetail.totalQuantity || 0 }}</a-descriptions-item>
        <a-descriptions-item label="审核时间">{{ parseTime(currentDetail.approveTime) }}</a-descriptions-item>
        <a-descriptions-item label="差异数量" >{{ currentDetail.totalDifference || 0 }}</a-descriptions-item>
        <a-descriptions-item label="差异金额" >{{ currentDetail.totalAmount || 0 }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{ currentDetail.remark || '-' }}</a-descriptions-item>
      </a-descriptions>
      <a-divider>盘点明细</a-divider>
      <a-table rowKey="id" :columns="itemColumns" :data-source="currentDetail?.checkItems || []" :pagination="false" size="small">
        <span slot="differenceType" slot-scope="text">
          <a-tag v-if="text === 1" color="red">盘盈</a-tag>
          <a-tag v-else-if="text === 2" color="green">盘亏</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="differenceQuantity" slot-scope="text">
          <span :style="{ color: text > 0 ? 'red' : (text < 0 ? 'green' : '') }">
            {{ text || 0 }}
          </span>
        </span>
        <span slot="differenceAmount" slot-scope="text">
          ¥{{ (text || 0).toFixed(2) }}
        </span>
      </a-table>
    </a-modal>

    <a-modal title="审核盘点差异" :visible="approveVisible" @ok="handleApproveSubmit" @cancel="approveVisible = false">
      <a-form-model :model="approveForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="approveForm.approved">
            <a-radio :value="true">通过</a-radio>
            <a-radio :value="false">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核意见">
          <a-textarea v-model="approveForm.remark" placeholder="请输入审核意见" :rows="4" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getCheckList, getCheckDetail, approveCheck, cancelCheck } from '@/api/retail/check'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'Check',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      approveVisible: false,
      currentDetail: null,
      approveForm: { checkId: undefined, approved: true, remark: '' },
      queryParam: { checkBatchNo: undefined,
        checkStatus: undefined,
        remark: undefined,
        goodsName: undefined,
        current: 1, size: 10 },
      pagination: { total: 0, current: 1, pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: total => `共 ${total} 条` },

      columns: [
        { title: '盘点批次号', dataIndex: 'checkBatchNo', width: 180, align: 'center' },
        { title: '门店名称', dataIndex: 'orgName', width: 120, align: 'center' },
        { title: '状态', dataIndex: 'checkStatus', width: 100, scopedSlots: { customRender: 'checkStatus' }, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 180, scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: '备注', dataIndex: 'remark', width: 150, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 250, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ],
      itemColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 150, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 120, align: 'center' },
        { title: '账面库存', dataIndex: 'bookStock', width: 100, align: 'center' },
        { title: '实际库存', dataIndex: 'actualStock', width: 100, align: 'center' },
        { title: '差异数量', dataIndex: 'differenceQuantity', width: 100, scopedSlots: { customRender: 'differenceQuantity' }, align: 'center' },
        { title: '差异类型', dataIndex: 'differenceType', width: 80, scopedSlots: { customRender: 'differenceType' }, align: 'center' },
        { title: '差异金额', dataIndex: 'differenceAmount', width: 100, align: 'center' }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    moment,
    parseTime(time) { return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-' },
    getStatusText(status) { const map = { 0: '待审核', 1: '审核通过', 2: '审核不通过', 3: '已取消' }; return map[status] || '-' },
    getStatusColor(status) { const map = { 0: 'orange', 1: 'green', 2: 'red', 3: 'red' }; return map[status] || 'default' },
    getList() {
      this.loading = true
      getCheckList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleTableChange(pagination) {
      this.queryParam.current = pagination.current
      this.queryParam.size = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() { this.queryParam.current = 1; this.getList() },
    resetQuery() { this.queryParam = { checkBatchNo: undefined, checkStatus: undefined, current: 1, size: 10 }; this.getList() },
    handleDetail(record) {
      getCheckDetail({ differenceId: record.id }).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) { this.approveForm.checkId = record.id; this.approveForm.approved = true; this.approveForm.remark = ''; this.approveVisible = true },
    handleApproveSubmit() {
      approveCheck(this.approveForm).then(() => {
        this.$message.success('审核成功')
        this.approveVisible = false
        this.getList()
      })
    },
    handleCancel(record) {
      this.$confirm({
        title: '确认取消',
        onOk: () => { cancelCheck({ checkId: record.id, remark: '' }).then(() => { this.$message.success('取消成功'); this.getList() }) }
      })
    }
  }
}
</script>
